import React from 'react';
import './CentersPage.css'; // Optional styling
import MyFooter from './MyFooter';

const CentersPage = () => {
  const centers = [
    {
      id: 1,
      name: "CHERANI PALLIATIVE CARE SOCIETY",
      address: "SUB STATION ROAD, CHERANI, KARUVAMBRAM PO, MANJERI- 676123",
      phone: "9072767367, 9447767367",
      mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d15658.508683130987!2d76.120064!3d11.141119999999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1747998678473!5m2!1sen!2sin",
      mapShortUrl: "https://goo.gl/maps/Y9FgwgjUhSWAjH7U6",
    },
    {
      id: 2,
      name: "PAYYNAD PALLIATIVE CARE CLINIC",
      address: "CHOLAKKAL, PAYYANAD (PO), MANJERI, PIN-676122",
      phone: "9207767367",
      mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3914.9353975367903!2d76.1564732!3d11.1181894!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba637a1698cc771%3A0xc776386a984b70bf!2sPAYYANAD%20VILLAGE%20PALLIATIVE%20CARE%20SOCIETY!5e0!3m2!1sen!2sin!4v1747999537425!5m2!1sen!2sin",
      mapShortUrl: "https://maps.app.goo.gl/6YwTjjXjsfjG2QzA6",
    },
    {
      id: 3,
      name: "MANJERI SOUTH PALLIATIVE CARE CLINIC",
      address: "GAIN QUARTERS, VELLARANGAL ROAD, VAYAPPARAPPADI, MANJERI, PIN:676121",
      phone: "8921550027",
      mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3915.0958218423875!2d76.1231511!3d11.1062361!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba635e88c792b7f%3A0xdc11bb15e58ac2dd!2sManjeri%20South%20palliative%20clinic!5e0!3m2!1sen!2sin!4v1747999640922!5m2!1sen!2sin",
      mapShortUrl: "https://maps.app.goo.gl/FAAXePA7w7DfeArp7",
    },
    {
      id: 4,
      name: "MANJERI WEST PALLIATIVE CARE CLINIC",
      address: "SUNDHARAM BUILDING, NETHAGI NAGAR SECOND STREET, MISRI, MANJERI",

      phone: "6282285833",
      mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3914.919037259076!2d76.1043471!3d11.119407699999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba637ba473e754d%3A0xde7b3f50922af9e6!2sMANJERI%20WEST%20PALLIATIVE%20CARE!5e0!3m2!1sen!2sin!4v1747999717682!5m2!1sen!2sin",
      mapShortUrl: "https://maps.app.goo.gl/XQaDjwDdNjMEvrwt8",
    },
    {
      id: 5,
      name: "TOWN PALLIATIVE CARE SOCIETY",
      address: "KIZHAKKETHALA, MANJERI, PIN:676122",
      phone: "8606110706",
      mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3914.850929127859!2d76.12549607504691!3d11.124478089046244!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTHCsDA3JzI4LjEiTiA3NsKwMDcnNDEuMSJF!5e0!3m2!1sen!2sin!4v1747999825162!5m2!1sen!2sin",
      mapShortUrl: "https://maps.app.goo.gl/M6SZo979ZYuEP7YR7",
    },
    {
      id: 6,
      name: "PULLOOR - KIDANGAZHI PALLIATIVE CARE SOCIETY",
      address: "SCHOOL ROAD JUNCTION, PULLOOR, KARUVAMBRAM POST, MANJERI",
      phone: "+919746967367",
      mapEmbedUrl: "https://www.google.com/maps?q=11.1379481,76.1027022&z=17&hl=en&output=embed",
      mapShortUrl: "https://www.google.com/maps?q=11.1379481,76.1027022&z=17&hl=en",
    },
     {
      id: 7,
      name: "KARUVAMBRAM WEST PALLIATIVE CARE SOCIETY",
      address: "RAMANKULAM, KARUVAMBRAM POST, MANJERI-676123",
      phone: "+919562285833",
      mapEmbedUrl: "https://www.google.com/maps?q=11.1349459,76.0939842&z=17&hl=en&output=embed",
      mapShortUrl: "https://www.google.com/maps?q=11.1349459,76.0939842&z=17&hl=en",

    },
    {
      id: 8,
      name: "NARUKARA VILLAGE WEST PALLIATIVE CARE SOCIETY",
      address: "ALUKKAL, PIN-676122",
      phone: "+917902285833",
      mapEmbedUrl: "https://www.google.com/maps?q=11.116932,76.0823846&z=17&hl=en&output=embed",
      mapShortUrl: "https://www.google.com/maps?q=11.116932,76.0823846&z=17&hl=en",
    },

  ];

  return (
    <div>
      
      {/* <div data-aos="fade-up" className="banner-container">
          </div> */}

       <h3>Coordinating Excellence in Palliative Care</h3>
            <p className="section-text">
             CAPCA is dedicated to enhancing the quality of palliative clinics , delivering dignified, innovative, and comprehensive care to patients. It serves as a coordinating body for voluntary palliative units and societies in the region. A governing council, comprising representatives from each society, oversees CAPCA’s activities. Monthly review meetings, along with on going training for nurses, doctors, and volunteers, ensure high standards of care:
             
              </p>
<div className='clipit'>
      <h2 className='text-white'>Affiliated Organisations at present</h2>
</div>
    <div className="centers-page">
            <div className="centers-list">
        {centers.map((center) => (
          <div data-aos="fade-up"  key={center.id} className="center-card">
            <h2>{center.name}</h2>
            <p><strong>Address:</strong> {center.address}</p>
            <p><strong>Phone:</strong> {center.phone}</p>
            <div className="map-container">
              <iframe
                title={`${center.name} Location`}
                src={center.mapEmbedUrl}
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
            <a href={center.mapShortUrl} target="_blank" rel="noopener noreferrer" className="map-link">
              Open in Google Maps ↗
            </a>
          </div>
        ))}
      </div>
    </div>
   
    </div>
  );
};

export default CentersPage;